<template>
    <div>
        <TodoList></TodoList>
    </div>

</template>

<script>
import TodoList from '../components/TodoList'
export default {
    components: {
        TodoList
    }
}
</script>

<style>

</style>